var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextsearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.75C5.85 21.75 1.25 17.15 1.25 11.5C1.25 5.85 5.85 1.25 11.5 1.25C17.15 1.25 21.75 5.85 21.75 11.5C21.75 17.15 17.15 21.75 11.5 21.75ZM11.5 2.75C6.67 2.75 2.75 6.68 2.75 11.5C2.75 16.32 6.67 20.25 11.5 20.25C16.33 20.25 20.25 16.32 20.25 11.5C20.25 6.68 16.33 2.75 11.5 2.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0014 22.7504C21.8114 22.7504 21.6214 22.6804 21.4714 22.5304L19.4714 20.5304C19.1814 20.2404 19.1814 19.7604 19.4714 19.4704C19.7614 19.1804 20.2414 19.1804 20.5314 19.4704L22.5314 21.4704C22.8214 21.7604 22.8214 22.2404 22.5314 22.5304C22.3814 22.6804 22.1914 22.7504 22.0014 22.7504Z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextsearchicon);
export default __webpack_public_path__ + "static/media/textsearchicon.3edefdf0578d40dcdad73613d362f50a.svg";
export { ForwardRef as ReactComponent };